import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './ProfileIconCard.module.css';

const LIKE = 'like';
const TWEET = "tweet";
const TOOLTIP = "tooltip"
const ProfileIconCard = props => {
  const { className, rootClassName, type } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (type) {
    case LIKE:
      return (
        <svg fill="#000000" width="15px" height="15px" viewBox="0 0 0.975 0.975" enable-background="new 0 0 52 52" space="preserve"><g><path d="M0.197 0.394h-0.094c-0.015 0 -0.028 0.013 -0.028 0.028v0.431c0 0.015 0.013 0.028 0.028 0.028H0.15c0.041 0 0.075 -0.034 0.075 -0.075V0.422c0 -0.015 -0.013 -0.028 -0.028 -0.028z" /><path d="M0.825 0.412h-0.112c-0.041 0 -0.075 -0.034 -0.075 -0.075V0.15c0 -0.041 -0.034 -0.075 -0.075 -0.075h-0.047c-0.015 0 -0.028 0.013 -0.028 0.028v0.112c0 0.099 -0.069 0.197 -0.159 0.197 -0.015 0 -0.028 0.013 -0.028 0.028v0.375c0 0.015 0.011 0.028 0.026 0.028 0.128 0.006 0.171 0.056 0.304 0.056 0.141 0 0.27 -0.015 0.27 -0.178V0.487c0 -0.041 -0.034 -0.075 -0.075 -0.075z" /></g></svg>
      );
    case TWEET:
      return (
        <svg width="11px" height="11px" viewBox="0 0 0.33 0.33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.114 0.289c0.104 0 0.16 -0.09 0.16 -0.168 0 -0.003 0 -0.005 0 -0.008A0.121 0.121 0 0 0 0.302 0.083a0.111 0.111 0 0 1 -0.032 0.009 0.059 0.059 0 0 0 0.025 -0.033 0.108 0.108 0 0 1 -0.036 0.014c-0.021 -0.024 -0.057 -0.025 -0.08 -0.003 -0.015 0.014 -0.021 0.036 -0.016 0.056 -0.045 -0.002 -0.088 -0.025 -0.116 -0.062 -0.015 0.027 -0.007 0.061 0.017 0.079A0.053 0.053 0 0 1 0.038 0.137v0.001c0 0.028 0.019 0.052 0.045 0.058 -0.008 0.002 -0.017 0.003 -0.026 0.001 0.007 0.024 0.029 0.041 0.053 0.041a0.11 0.11 0 0 1 -0.07 0.025c-0.005 0 -0.009 0 -0.013 -0.001A0.154 0.154 0 0 0 0.114 0.289Z" stroke="#fff" stroke-width="0.0275" stroke-linecap="round" stroke-linejoin="round" /></svg>
      );
      case TOOLTIP:
        return (
          <svg width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path fill="#1a67d7" fill-rule="evenodd" d="M8,16 C3.58172,16 0,12.4183 0,8 C0,3.58172 3.58172,0 8,0 C12.4183,0 16,3.58172 16,8 C16,12.4183 12.4183,16 8,16 Z M4.4325,6.19122 C4.4325,5.7729 4.57483,5.34907 4.8595,4.91974 C5.14417,4.49041 5.5595,4.13484 6.1055,3.85303 C6.6515,3.57121 7.28848,3.43033 8.01648,3.43033 C8.69315,3.43033 9.2905,3.54811 9.8085,3.78369 C10.3265,4.01927 10.7267,4.33961 11.009,4.74472 C11.2913,5.14983 11.4325,5.59017 11.4325,6.06573 C11.4325,6.44002 11.352,6.76805 11.191,7.04987 C11.03,7.33168 10.8387,7.57497 10.617,7.77972 C10.3953,7.98448 9.9975,8.32904 9.42349,8.81342 C9.26483,8.94992 9.13766,9.06989 9.04199,9.17337 C8.94633,9.27685 8.87516,9.37153 8.82849,9.4574 C8.4428,10.3468 6.77018,10.2464 7.0925,9.00165 C7.21383,8.73084 7.37483,8.49306 7.5755,8.2883 C7.77617,8.08354 8.04681,7.84026 8.38748,7.55844 C8.68615,7.31185 8.902,7.12583 9.035,7.00034 C9.168,6.87484 9.28,6.73502 9.371,6.5809 C9.462,6.42678 9.50748,6.25946 9.50748,6.07892 C9.50748,5.72665 9.36867,5.42944 9.091,5.18726 C8.81334,4.94507 8.45515,4.82397 8.01648,4.82397 C7.50314,4.82397 7.12514,4.94616 6.88248,5.19055 C6.63981,5.43494 6.43448,5.79491 6.26648,6.27048 C6.10781,6.76806 5.80683,7.01685 5.36349,7.01685 C5.10216,7.01685 4.88166,6.92988 4.702,6.75595 C4.52233,6.58202 4.4325,6.39378 4.4325,6.19122 Z M8,13 C7.44771,13 7,12.5523 7,12 C7,11.4477 7.44771,11 8,11 C8.55229,11 9,11.4477 9,12 C9,12.5523 8.55229,13 8,13 Z"/>
        </svg>
        );
    
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

ProfileIconCard.defaultProps = {
  className: null,
  rootClassName: null,
  type: 'default',
};

ProfileIconCard.propTypes = {
  className: string,
  rootClassName: string,
  type: string,
};

export default ProfileIconCard;
